import Brace from "backbone.brace";
import DiagCode from "./diag-code";
import Member from "./member";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: Number,
    canEdit: Boolean,
    canVoid: Boolean,
    claimNbr: String,
    diagnosisCode: DiagCode,
    projectName: String,
    memberId: Number,
    member: Member,
    fromDateOfService: String,
    throughDateOfService: String,
    claimCommercialPlanId: String,
    disposition: String,
    auxType: String,
    placeOfServiceCode: String,
    supplementalReasonCode: String,
    customerReferenceNumber: String,
    sourceReferenceNumber: String,
    providerId: Number,
    providerNumber: String,
    providerFirstName: String,
    providerLastName: String,
    providerReferenceNumber: String,
    assessmentId: String,
    diagRenderingProviderName: String,
    diagRenderingProviderNpi: String,
    auditDisposition: String,
    auditCommercialPlanId: String,
    auditDrgStatus: String,
    auditFileSid: Number,
    action: String,
    mappedHCCs: String,

    // leave these as a raw Objects so they can be serializied and PUT
    // back to the API untouched. See extension, drg-deletes-edit-form for their UI
    // implementation
    statusReasons: Object,
    users: Object,

    // raw objects that will not be serialized
    notes: Object,
  },

  stale: ["notes"],

  defaults: {
    id: null,
    canEdit: false,
    canVoid: false,
    claimNbr: null,
    diagnosisCode: null,
    projectName: null,
    memberId: null,
    member: null,
    fromDateOfService: null,
    throughDateOfService: null,
    claimCommercialPlanId: null,
    disposition: null,
    auxType: null,
    placeOfServiceCode: null,
    supplementalReasonCode: null,
    customerReferenceNumber: null,
    sourceReferenceNumber: null,
    providerId: null,
    providerNumber: null,
    providerFirstName: null,
    providerLastName: null,
    providerReferenceNumber: null,
    assessmentId: null,
    diagRenderingProviderName: null,
    diagRenderingProviderNpi: null,
    auditDisposition: null,
    auditCommercialPlanId: null,
    auditDrgStatus: null,
    auditFileSid: null,
    action: null,
    mappedHCCs: null,
    statusReasons: null,
    users: null,
    notes: null,
  },

  toJSON() {
    return _.omit(this.attributes, this.stale);
  },
});

export { Model as default };
